const BASE_URL = '/proxy/api/lead/submitSubscribe';

export interface SubscribeLeadInput {
  firstName: string;
  lastName: string;
  email: string;
  postcode: string;
}

export const submitSubscribeLead = (data: SubscribeLeadInput) =>
  fetch(BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  }).then((res) => {
    if (!res.ok) throw new Error('Lead submission failed.');
    return res.json();
  });
